import React, { useContext, useEffect, useState, useCallback } from "react";
import Card from "react-bootstrap/Card";
import { Container, Row, Col, Button, Modal, Spinner } from "react-bootstrap";
import { dataContext } from "components/dataContext/dataContext";
import DataTable from "react-data-table-component";
import "../assets/css/dataTable.css";

import { AccountContext } from "components/Account/Account";
import consultaDLQ from "api/consultaDLQ";



function DLQMonitor() {
  const { data } = useContext(dataContext);
  const { getSession } = useContext(AccountContext);

  const [queues, setQueues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [redriving, setRedriving] = useState({});
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');
  const handleClose = () => {
    setShow(false)
  };
  const fetchQueues = useCallback(async () => {
    setLoading(true);
    try {
      const idToken = await getSession().then((session) => session.idToken.jwtToken);
      // console.log("Fetching DLQ data...");
      const resp = await consultaDLQ.getDLQ(idToken);
      setQueues(resp?.data.queues ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [getSession]);

  useEffect(() => {
    fetchQueues();
  }, [fetchQueues]);

  const redriveDLQ = useCallback(
    async (row) => {
      try {
        setShow(true);
        setLoadingModal(true);
        const idToken = await getSession().then((session) => session.idToken.jwtToken);
        // Llama a la API para redrive
        await consultaDLQ.redriveDLQ(row.queueName, idToken)
        // Muestra mensaje de éxito
        setMessage(`Redrive iniciado para la cola ${row.queueName}. Por favor, monitorea el estado de las colas para verificar el progreso.`);
        setRedriving((prev) => ({ ...prev, [row.queueName]: true }));
        // refresca conteos
        await fetchQueues();
      } catch (err) {
        console.log(err);
        setMessage(`Error al iniciar redrive para la cola ${row.queueName}.`);
      } finally {
        setLoadingModal(false);
        setRedriving((prev) => ({ ...prev, [row.queueName]: false }));

      }
    },
    [getSession, fetchQueues]
  );

  const columns = [
    {
      name: "Cola",
      selector: (row) => row.queueName.split('_')[0] + " " + row.queueName.split('_')[1],
      sortable: true,
      wrap: true,
      width: '15%',
    },
    {
      name: "Visible",
      selector: (row) => row.visible ?? 0,
      sortable: true,
      right: true,
      width: '15%',
    },
    {
      name: "No visible",
      selector: (row) => row.notVisible ?? 0,
      sortable: true,
      right: true,
      width: '15%',
    },
    {
      name: "Delayed",
      selector: (row) => row.delayed ?? 0,
      sortable: true,
      right: true,
      width: '15%',
    },
    {
      name: "Total",
      selector: (row) => row.total ?? 0,
      sortable: true,
      right: true,
      width: '15%',
    },
    {
      name: "Acciones",
      cell: (row) => {
        const hasMessages = (row.visible ?? 0) > 0;
        const isBusy = !!redriving[row.queueName];

        return (
          <Button
            size="sm"
            variant="warning"
            disabled={!hasMessages || isBusy}
            onClick={() => redriveDLQ(row)}
          >
            {isBusy ? "Redriving..." : "Redrive"}
          </Button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,

    },
  ];

  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card className="strpied-tabled-with-hover">
            <Card.Header>
              <Card.Title as="h4">Monitor DLQ C2C</Card.Title>
              <p className="card-category">
                Última Actualización: {data?.lastcheck}
              </p>
            </Card.Header>

            <Card.Body className="table-full-width table-responsive px-0">
              <DataTable
                className="-striped -highlight"
                fixedHeader
                columns={columns}
                data={queues}
                progressPending={loading}
                persistTableHead
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* Modal redrive */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Redrive DLQ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingModal && <Spinner animation="border" role="status" className='sticky-top'></Spinner>}
          <p>{!loadingModal && <> {message} </>}</p>
        </Modal.Body>
        <Modal.Footer>
          {!loadingModal && <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>}

        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default DLQMonitor;
